import script from "./ClientCabinetList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetList.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetList.vue?vue&type=style&index=0&id=f147d620&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f147d620"]])

export default __exports__